
// Save Buy Now item
export const setBuyNowItem = (item) => {
    localStorage.setItem("buyNowItem", JSON.stringify(item));
};

// Get Buy Now item
export const getBuyNowItem = () => {
    return JSON.parse(localStorage.getItem("buyNowItem"));
};

// Clear Buy Now item
export const clearBuyNowItem = () => {
    localStorage.removeItem("buyNowItem");
};